// Brand specific configuration
// This file is required for each brand
// Don't include any secrets here, they should be in the .env file
import { BaseBrandThemeConfig } from '@aspendental/shared-components-web';

const config: BrandThemeConfig = {
	...BaseBrandThemeConfig,
	name: 'Aspen Dental',
	logo: {
		dark: 'https://images.ctfassets.net/m8zwsu9tyucg/7jzYqWlL2Z1NyUWPgR7mpc/922ffe5db0d5cd28bcb42653e7d9a5e6/AspenLogoDark.svg',
		light: 'https://images.ctfassets.net/m8zwsu9tyucg/1OLI6iOYAFp0Mvqm46Yyor/8908782b135cb2d577fe727a536434b1/logo-aspendental-white.svg',
	},
	services: {
		prod: {
			...BaseBrandThemeConfig.services.prod,
			GOOGLE_MAP_API_KEY: 'AIzaSyCZf5YB0oaQGSP0dX9AScHqFYysYi0HPaw',
		},
		nonprod: {
			...BaseBrandThemeConfig.services.nonprod,
			GOOGLE_MAP_API_KEY: 'AIzaSyA_SMV0ZyKn3u0uD1dPUhcVpaXpQWGvcCc',
		},
	},
	siteURL: 'https://www.aspendental.com',
	features: {
		redirects: [],
		rewrite: {},
		favIcons: {},
		sitemap: {
			additionalSitemapIndexes: [
				'https://www.aspendental.com/dentist/sitemap-index.xml',
				'https://www.aspendental.com/schedule-an-apointment/sitemap-index.xml',
				'https://www.aspendental.com/search/sitemap-index.xml',
			],
		},
		analytics: {
			enabled: process.env.NODE_ENV === 'development' ? false : true,
			vwoAccountId: '613301',
			gtmId: 'GTM-NTW7353',
			gtmPatientPortalId: 'GTM-T6NM8JLH',
			inline: false,
		},
		salesforce: {
			enabled: false,
		},
		sentry: {
			enabled: true,
		},
		chat: {
			enabled: true,
			enabledStates: 'FL,TX,GA,IL',
			chatBotURL:
				'https://aspendental.amelia.com/Amelia/ui/aspencallcenter/chat?embed=iframe&domainCode=aspencallcenter',
			isIconButton: false,
		},
		notFoundPage: {
			desktopBackgroundImage:
				'https://images.ctfassets.net/m8zwsu9tyucg/AxWVBlTbpeJHO04OOM3SR/4e3ed05d72259d8aeb71d6c6f4bcafdf/WellNow404.png?q=90&fit=fill&f=face&fm=webp',
			mobileBackgroundImage:
				'https://images.ctfassets.net/m8zwsu9tyucg/4NGVlzvau9wEqmZd5h1pBt/0bd600d7d7c0f569d31fa1848b631806/WellNow404_M.jpg?q=90&fit=fill&f=face&fm=webp',
		},
		livePreview: {
			local: 'https://local.aspendental.com:8443',
			stage: 'https://wwwstg.aspendental.com',
			prod: 'https://www.aspendental.com',
		},
		footer: {
			lite: false,
			withSimpleLayout: true,
		},
		blogs: {
			root: '',
		},
		migration: {
			paths: [],
		},
	},
	featureFlags: {
		...BaseBrandThemeConfig.featureFlags,
		showMobileHeaderLocationBar: false,
		enablePatientPortalPhase2: false,
		enablePatientPortalNavigation: false,
		officeRollout: {
			documentsAndRecordsLocations: [],
			cardAuthorizationLocations: [],
			sleepApneaLocations: [],
			loginLanguageToggle: false,
			enableFormsLanguageToggle: [],
			enableAiClinicalTools: [],
		},
	},
	contentfulAppId: 'AspenDental - Scheduling' as ContentfulAppId,
	confirmationStepId: '1MSmdxPimCJCOenlBFoAGA',
	themeId: 'aspendental' as TagThemeType,
	themeColor: '#002855',
};

export default config;
